import { faqData } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100/60">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950">常见问题</h2>
          <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-xl mx-auto">
            关于飞飞漫画网漫画全集在线看的常见疑问，快速了解平台功能
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqData.map((item, idx) => (
            <div key={idx} className="bg-background-50 rounded-lg overflow-hidden">
              <div className="p-5 md:p-6">
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center bg-primary-100 rounded-full flex-shrink-0 mt-0.5">
                    <span className="text-xs font-bold text-primary-600">Q</span>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 mb-2">
                      {item.q}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}